import { forwardRef } from 'react';

export const EmptyColumnHeaders = forwardRef(() => {
  return null;
});

EmptyColumnHeaders.displayName = 'EmptyColumnHeaders';
